var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Upload-Circle--Streamline-Sharp.svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Upload Circle Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat/01-Interface-Essential/11-Upload-Download/upload-circle--arrow-circle-download-internet-network-server-up-upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#8fbffa",
    fillRule: "evenodd",
    d: "M12 24c-3.1826 0 -6.23484 -1.2643 -8.48528 -3.5147C1.26428 18.2348 0 15.1826 0 12c0 -3.1826 1.26428 -6.23484 3.51472 -8.48528C5.76516 1.26428 8.8174 0 12 0s6.2348 1.26428 8.4853 3.51472C22.7357 5.76516 24 8.8174 24 12s-1.2643 6.2348 -3.5147 8.4853C18.2348 22.7357 15.1826 24 12 24Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fill: "#2859c5",
    fillRule: "evenodd",
    d: "M16.25 11.75v-1.5607L12 5.93933 7.75 10.1893V11.75h2.75V18h3v-6.25h2.75Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcircle);
export default __webpack_public_path__ + "static/media/upcircle.0524b5a6213162bd85799d86c619ff72.svg";
export { ForwardRef as ReactComponent };